var m = require('mithril');
var key = require('../../libs/keybindings');
var Model = require('../../libs/Model');
var modal = require('../../layout/components/modal');
var UserModel = Object.assign({}, require('../../../../../models/users/user'), Model);
var UserAdminModel = Object.assign({}, require('../../../../../models/users/userAdmin'), Model);
var UserForm = Object.assign({}, UserModel, Model);
UserForm.fields = Object.assign({}, UserForm.fields, UserAdminModel.fields);
delete UserForm.fields.username;
delete UserForm.fields.useUsaUnits;

modal.once('closed', function () {
  key.deleteScope('modal');
  key.setScope('home');
});


UserForm.editDialogue = function (record) {
  UserForm.initForm(record)

  var submit = function () {
    UserForm.form.inactive() == "1" ? UserForm.form.inactive("0") : UserForm.form.inactive("1");
    UserForm.save()
    .then( response => {
      key.unbind('enter');
      modal.vm.close();
      m.redraw();
    })
  };

  key.setScope('modal');
  key('enter', 'modal', submit);

  modal.vm.title( UserForm.form.inactive() == "1" ? 'Activate user ?' : 'Deactivate user?')
  modal.vm.buttons([
    {
      label: "Confirm",
      class: "btn-good",
      func: submit
    }
  ])

  modal.vm.open();
}


module.exports = UserForm;
